import { memo, useState } from 'react';

export interface ExpandablePatternIdProps {
    uniqueId: string;
}

export const ExpandablePatternId = memo(
    ({ uniqueId }: ExpandablePatternIdProps) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const shortId = `${uniqueId.slice(0, 10)}…`;

        return (
            <span
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ cursor: 'pointer' }}
            >
                {isExpanded ? uniqueId : shortId}
            </span>
        );
    },
);

ExpandablePatternId.displayName = 'ExpandablePatternId';
